import { styled as muiStyled } from '@mui/material';

export const StyledIframe = muiStyled('iframe')(() => ({
  display: 'none',
}));
